<div class="header">
  <div class="header-cont">
    <h2>{{ 'poi_list.title' | translate }}</h2>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <p>{{ 'poi_list.title_descr' | translate }}</p>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'poi_list.last_added' | translate }}</h3>
  </div>
</div>

<div class="single-section margin-small top">
  <div class="section-cont">
    <mat-carousel
      #matCarousel
      [timings]="timings"
      [autoplay]="autoplay"
      [interval]="interval"
      [loop]="loop"
      [hideArrows]="hideArrows"
      [hideIndicators]="hideIndicators"
      [color]="color"
      [maxWidth]="maxWidth"
      [proportion]="proportion"
      [useKeyboard]="useKeyboard"
      [useMouseWheel]="useMouseWheel"
      [orientation]="orientation"
      [slides]="slides"
      [maintainAspectRatio]="maintainAspectRatio"
      [slideHeight]="slideHeight"
    >
      <mat-carousel-slide
        #matCarouselSlide
        *ngFor="let most_viewed_poi of (poiCarousel | slice:-10)"
        [image]="imageUrl(most_viewed_poi)"
        [overlayColor]="overlayColor"
        [hideOverlay]="hideOverlay"
      >
      <div class="carousel-list-page">
        <div class="carousel-cont">
            <h2>{{most_viewed_poi.poi_name[current_lang]}}</h2>
            <p>{{most_viewed_poi.short_descr[current_lang]}}</p>
            <button
              mat-raised-button
              [routerLink]="['/home/poi/'+most_viewed_poi.id]">
              {{ 'home.link_btn' | translate }}
            </button>
          </div>
        </div>
      </mat-carousel-slide>
    </mat-carousel>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters">
    <h3>{{ 'poi_list.poi_list_title' | translate }}</h3>
    <div class="filters">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title *ngIf="!loadingTheme; else loadingThemePoiDesktop">
            {{ 'poi_list.filter_theme' | translate }}
          </mat-panel-title>
          <ng-template #loadingThemePoiDesktop>
            <mat-panel-title>
              {{ 'poi_list.filter_theme' | translate }}
              <mat-progress-spinner
                  matSuffix
                  color="primary"
                  mode="indeterminate"
                  [diameter]="24"
                  style="margin-left: 5px;">
              </mat-progress-spinner>
            </mat-panel-title>
          </ng-template>
        </mat-expansion-panel-header>
        <mat-selection-list color="primary" class="themes-filter" #themesFilterDesktop (selectionChange)="themesFilterFunction(false)">
          <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
            {{single_theme.name[current_lang]}}
          </mat-list-option>
        </mat-selection-list>
      </mat-expansion-panel>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'poi_list.search_label' | translate }}</mat-label>
        <input matInput (keyup)="inputFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
        <mat-icon *ngIf="!loadingSearch; else loadingSearchPoiDesktop" matSuffix>search</mat-icon>
        <ng-template #loadingSearchPoiDesktop>
          <mat-progress-spinner
              matSuffix
              color="primary"
              mode="indeterminate"
              [diameter]="24">
          </mat-progress-spinner>
        </ng-template>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters-smaller">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title *ngIf="!loadingTheme; else loadingThemePoiMobile">
          {{ 'poi_list.filter_theme' | translate }}
        </mat-panel-title>
        <ng-template #loadingThemePoiMobile>
          <mat-panel-title>
            {{ 'poi_list.filter_theme' | translate }}
            <mat-progress-spinner
                matSuffix
                color="primary"
                mode="indeterminate"
                [diameter]="24"
                style="margin-left: 5px;">
            </mat-progress-spinner>
          </mat-panel-title>
        </ng-template>
      </mat-expansion-panel-header>
      <mat-selection-list color="primary" class="themes-filter" #themesFilterMobile (selectionChange)="themesFilterFunction(true)">
        <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
          {{single_theme.name[current_lang]}}
        </mat-list-option>
      </mat-selection-list>
    </mat-expansion-panel>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'poi_list.search_label' | translate }}</mat-label>
      <input matInput (keyup)="inputFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon *ngIf="!loadingSearch; else loadingSearchPoiMobile" matSuffix>search</mat-icon>
      <ng-template #loadingSearchPoiMobile>
        <mat-progress-spinner
            matSuffix
            color="primary"
            mode="indeterminate"
            [diameter]="24">
        </mat-progress-spinner>
      </ng-template>
    </mat-form-field>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <div *ngIf="!loading; else loadingPagePoi" class="element-card">
      <mat-card *ngFor="let single_poi of poi_list_filtered | paginate: { itemsPerPage: poi_list_size, currentPage: poi_list_page + 1, totalItems: poi_list_total, id: 'paginationPoi' }" [routerLink]="['/home/poi/'+single_poi.id]">
        <img mat-card-image [src]="imageUrl(single_poi)" [alt]="single_poi.poi_name[current_lang]">
        <mat-card-content>
          <a><h4>{{single_poi.poi_name[current_lang]}}</h4></a>
          <p>{{single_poi.short_descr[current_lang]}}</p>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-template #loadingPagePoi>
      <div class="element-card">
        <mat-progress-spinner
            color="primary"
            mode="indeterminate">
        </mat-progress-spinner>
      </div>
    </ng-template>
    <pagination-controls
      *ngIf="poi_list_total > poi_list_size"
      class="pr-pagination"
      (pageChange)="pageChange($event)"
      id="paginationPoi"
      [previousLabel]="'paginator.prev' | translate"
      [nextLabel]="'paginator.next' | translate"
    ></pagination-controls>
  </div>
</div>
